<input type="number" [(ngModel)]="params.data.Packed" [ngClass]="{equal:params.data.Qty>=params.data.Packed,greater:params.data.Qty<params.data.Packed}">